export default "__VITE_ASSET__Cy$erD92__"